// Downpay owns the purchase-option controls; this only clarifies its 25% label.
(() => {
  if (window.notcoyDownpayDepositAmountInitialized) return;
  window.notcoyDownpayDepositAmountInitialized = true;

  function initialize() {
    const productInfo = document.querySelector('product-info[data-downpay-deposit-amount]');
    if (!productInfo) return;

    function updateLabel() {
      const label = productInfo.querySelector('#purchase-option-deposit-wrapper .deposit-option-label');
      if (!label) return;

      let amount = label.querySelector('[data-downpay-deposit-amount-label]');
      // Only augment the 25% plan. Other deposit rates or fixed amounts are left to Downpay.
      if (!amount && /^25\s*%\s*deposit$/i.test(label.textContent.trim())) {
        amount = document.createElement('span');
        amount.setAttribute('data-downpay-deposit-amount-label', '');
        label.appendChild(document.createTextNode(': '));
        label.appendChild(amount);
      }

      if (amount) {
        const text = productInfo.dataset.downpayDepositAmount;
        if (amount.textContent !== text) amount.textContent = text;
      }
    }

    // The app may inject or replace its controls after the theme has loaded.
    new MutationObserver(updateLabel).observe(productInfo, { childList: true, subtree: true });
    updateLabel();

    // The theme fetches fresh section HTML for each variant, including its Shopify-formatted price.
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (String(data.productId) !== productInfo.dataset.productId) return;
      const updatedInfo = data.parsedHTML.querySelector('product-info[data-downpay-deposit-amount]');
      if (!updatedInfo) return;
      productInfo.dataset.downpayDepositAmount = updatedInfo.dataset.downpayDepositAmount;
      updateLabel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
